import { FormatMessageType } from '@hooks/useValidation';
import { LOGIN_REQUIRED, PASSWORD_REQUIRED } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

export const loginSchema = (formatMessage: FormatMessageType) =>
  Yup.object({
    login: Yup.string().required(formatMessage({ id: LOGIN_REQUIRED })),
    password: Yup.string().required(formatMessage({ id: PASSWORD_REQUIRED })),
  });
